export interface IPage {
    title: string;
    href: string;
    children?: IPage[];
}

export const allPages: IPage[] = [
    {
        title: "Home",
        href: "/"
    },
    {
        title: "Finsense",
        href: "/finsense",

        children: [
            {
                title: "Authentication",
                href: "/finsense#auth"
            },
            {
                title: "Consent Flow",
                href: "/finsense#consent-flow"
            },
            {
                title: "Data Flow",
                href: "/finsense#data-flow"
            },
            {
                title: "Supporting APIs",
                href: "/finsense#supporting-apis"
            },
            {
                title: "Metrics API",
                href: "/finsense#metrics-api"
            },
            {
                title: "Notification",
                href: "/finsense#notification"
            },
            {
                title: "RBiH",
                href: "/finsense#rbih"
            },
            {
                title: "AA Switch API",
                href: "/finsense#aa-switch-api"
            }
        ]
    },
    {
        title: "ConnectHub",
        href: "/connect-hub"
    },
    {
        title: "WealthScape",
        href: "/wealth-scape",
        children: [
            {
                title: "Authentication",
                href: "/wealth-scape#auth"
            },
            {
                title: "Notifications",
                href: "/wealth-scape#notifications"
            },
            {
                title: "Subscription",
                href: "/wealth-scape#subscription"
            },
            {
                title: "AA Connect",
                href: "/wealth-scape#aa-connect"
            },
            {
                title: "MFC Connect",
                href: "/wealth-scape#mfc-connect"
            },
            {
                title: "Deposit Insights",
                href: "/wealth-scape#deposit-insights"
            },
            {
                title: "Mutual Fund Insights",
                href: "/wealth-scape#mutual-fund-insights"
            },
            {
                title: "Demat Insights",
                href: "/wealth-scape#demat-insights"
            },
            {
                title: "Equity Insights",
                href: "/wealth-scape#equity-insights"
            },
            {
                title: "ETF Insights",
                href: "/wealth-scape#etf-insights"
            },
            {
                title: "Equity & ETF Insights",
                href: "/wealth-scape#equity-etf-insights"
            },
            {
                title: "NPS Insights",
                href: "/wealth-scape#nps-insights"
            },
            {
                title: "Recurring Deposit Insights",
                href: "/wealth-scape#recurring-deposit-insights"
            },
            {
                title: "Term Deposit Insights",
                href: "/wealth-scape#term-deposit-insights"
            },
            {
                title: "Others",
                href: "/wealth-scape#others"
            }
        ]
    },
    {
        title: "Prism",
        href: "/prism",
        children: [

        ]
    },
    {
        title: "Risk Gauge",
        href: "/risk-gauge"
    },
];